import React, { useEffect, useLayoutEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useLeftBar } from "../../context/LeftBar";
import { useSelections } from "../../context/Selections";
import NavItem from "./MenuItem/NavItem";
import utils from "../../QlikUtils";

function LeftSideMenu({ app, config, logo }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [dataAtualizacao, setDataAtualizacao] = useState("");
  const screenBreakpoint = 500;

  const { t, i18n } = useTranslation();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { selections } = useSelections();
  const [selectedYear, setSelectedYear] = useState("FY23");

  async function initialSelecao() {
    await app.variable.getContent("vAtualizacao", (reply) => {
      const data = reply.qContent.qString;
      setDataAtualizacao(data);
    });
  }

  useEffect(() => {
    if (selections.length) {
      const selection =
        selections.find((selection) => selection.qField === "Ano")
          ?.qSelected === "FY23" ?? false;
      setSelectedYear(selection ? "FY23" : "FY24");
    }
  }, [selections]);


  const changeLanguage = async (tempApp, language) => {
    localStorage.setItem("language", language);
    i18n.changeLanguage(language);
    await tempApp
      .field(config.app.langVar)
      .selectMatch(utils.languageHandleQVF(language));
  };

  useLayoutEffect(() => {
    let language = params.get("lang");
    if (!language) {
      language = localStorage.getItem("language");
    }
    language = utils.guardLanguage(language);
    changeLanguage(app, language);
  }, []);

  useEffect(() => {
    initialSelecao();
    window.addEventListener("resize", () => setScreenWidth(window.innerWidth));

    return () => {
      window.removeEventListener("resize", () =>
        setScreenWidth(window.innerWidth)
      );
    };
  }, []);

  const { leftBarOpened, setLeftBarOpened } = useLeftBar();
  return (
    <div className={leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu"}>
      <div className="leftSideHeader">
        <div className={leftBarOpened ? "logo" : "logo is-hidden"}>
          <img
            style={{ width: "200px", height: "60px" }}
            src={logo}
            alt="logo"
          />
        </div>
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
          className={leftBarOpened ? "" : "align-left"}
        >
          <i
            className={
              leftBarOpened
                ? "fal fa-arrow-left close-desktop"
                : "fal fa-arrow-right"
            }
          />
          <i className={leftBarOpened ? "fal fa-times close-mobile" : ""} />
        </button>
      </div>
      <div>&nbsp;</div>

      {leftBarOpened && (
        <>
          <div className="info-client">
            <div>
              <h4>Diageo</h4>
              <p>Loja de Conveniência</p>
            </div>
          </div>
          <div style={{ boxShadow: "inset 0 -1px 0 #184952", width: "100%" }}>
            &nbsp;
          </div>
        </>
      )}

      <div className="leftSideContent">
        <ul>
          <NavItem icon="fas fa-chart-pie" name="One Page" path="/one-page" />
        </ul>
        <ul>
          <NavItem
            icon={
              screenWidth < screenBreakpoint
                ? "fas fa-chart-bar"
                : "fas fa-chart-bar"
            }
            name="Performance"
            path="/performance/sellout"
            subpages={[
              {
                id: 1,
                url: "/performance/sellout",
                name: "Sell Out",
              },
              {
                id: 2,
                url: "/performance/coverage-total",
                name: "Cobertura Total",
              },
              {
                id: 3,
                url: "/performance/coverage-5-of-6",
                name: "Cobertura Qualificada",
              },
              {
                id: 4,
                url: "/performance/general",
                name: "Geral",
              },
            ]}
          />
        </ul>
        <ul>
          <NavItem
            icon="fas fa-file-alt"
            name="Investimentos"
            path="/investments"
          />
        </ul>
        <ul>
          <NavItem
            name="Oportunidades"
            path="/opportunity/coverage-5-of-6"
            icon={
              screenWidth < screenBreakpoint ? "fas fa-tags" : "fas fa-tags"
            }
            // name={t('menu')[1].title}
            // subpages={selectedYear === "FY23" ? [
            //   {
            //     id: 1,
            //     url: "/opportunity/coverage-5-of-6",
            //     name: "Cobertura Qualificada",
            //   },
            //   {
            //     id: 2,
            //     url: "/opportunity/inovation",
            //     name: "Inovação",
            //   },
            //   {
            //     id: 3,
            //     url: "/opportunity/opportunity",
            //     name: "Oportunidade",
            //   },
            // ] : [
            //   {
            //     id: 1,
            //     url: "/opportunity/coverage-5-of-6",
            //     name: "Cobertura Qualificada",
            //   },
            //   {
            //     id: 2,
            //     url: "/opportunity/combos",
            //     name: "Combos",
            //   }
            // ]}
            subpages={ [
              {
                id: 1,
                url: "/opportunity/coverage-5-of-6",
                name: "Cobertura Qualificada",
              }
            ]}
          />
        </ul>
        {leftBarOpened && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              paddingLeft: "10px",
              color: "white",
              justifyContent: "start",
              marginTop: "20px",
              fontSize: "14px",
            }}
          >
            <h4>Atualizado em: {dataAtualizacao} </h4>
          </div>
        )}
      </div>
    </div>
  );
}

LeftSideMenu.defaultProps = {
  logo: "",
};

LeftSideMenu.propTypes = {
  logo: PropTypes.string,
};

export default LeftSideMenu;
